import { CheckAvailableCreditCTA } from "./ctas";
export var BrandReferralUseCreditIA = function BrandReferralUseCreditIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize), BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return CheckAvailableCreditCTA(strictLocalize);
};
var BRAND_REFERRALS_USE_CREDIT_TITLE = function BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "zvQaIx",
    defaultMessage: [{
      "type": 0,
      "value": "Comment utiliser le crédit obtenu grâce au parrainage de marques ?"
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize) {
  return strictLocalize({
    id: "dkqwac",
    defaultMessage: [{
      "type": 0,
      "value": "Après avoir reçu votre crédit, celui-ci est automatiquement déduit de votre prochaine commande, quelle que soit la marque. Aucune action n'est nécessaire. Si vous ne dépensez pas tout votre crédit en une seule fois, le montant restant sera reporté. Pour consulter le solde de votre crédit, rendez-vous dans « Compte », puis « Crédit disponible »."
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize) {
  return strictLocalize({
    id: "DthCDL",
    defaultMessage: [{
      "type": 0,
      "value": "Pour connaître le montant du crédit que vous avez obtenu grâce aux parrainages de marques, rendez-vous dans « Compte », puis « Parrainer des marques », et sélectionnez l'onglet « Inscrites »."
    }]
  });
};